export default {
      id: "ic-nav-swiper-next-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-swiper-next-usage",
      toString: function () {
        return this.url;
      }
    }